import React from "react";
import { FaCheckCircle } from "react-icons/fa";

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About Me</h2>
          <p className="section-subtitle">
            Bridging software engineering discipline with enterprise infrastructure and security operations.
          </p>
        </div>

        <div className="about-grid">
          <div className="about-content">
            <p className="about-lead">
              As an Information Technology graduate from the <strong>University of Ghana</strong>, I combine a strong foundation in software engineering, database administration, and cloud technologies with hands-on enterprise IT infrastructure and cybersecurity practices.
            <br />
              My approach connects the entire technical lifecycle - from architecting full-stack web applications and implementing rigorous test automation pipelines, to provisioning secure networks, administering Active Directory, and monitoring mission-critical systems in enterprise banking environments.
            </p>
          </div>

          <div className="value-cards">
            <div className="value-card">
              <h3>Core Value Pillars</h3>
              <ul>
                <li>
                  <FaCheckCircle className="icon-check" />
                  <span>
                    <strong>Full-Stack & Resilient Architecture:</strong> Developing responsive, high-performance web applications (React, Next.js, Node.js) with end-to-end type safety and automated testing.
                  </span>
                </li>
                <li>
                  <FaCheckCircle className="icon-check" />
                  <span>
                    <strong>Infrastructure & High Availability:</strong> Practical experience in enterprise system administration, network configurations, server maintenance, and proactive incident resolution.
                  </span>
                </li>
                <li>
                  <FaCheckCircle className="icon-check" />
                  <span>
                    <strong>Security & Governance First:</strong> Integrating defensive coding, OWASP Top 10 mitigation, IAM policies, and compliance standards from development to deployment.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;

